import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import styles from './PrivacyPolicy.module.css';

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.legalPage}>
      <div className={styles.content}>
        <h1 className={styles.title}>{t('privacyPolicy.title')}</h1>
        <p className={styles.lastUpdated}>{t('privacyPolicy.lastUpdated')}</p>

        <section className={styles.section}>
          <h2>{t('privacyPolicy.intro.title')}</h2>
          <p>{t('privacyPolicy.intro.text')}</p>
        </section>

        <section className={styles.section}>
          <h2>{t('privacyPolicy.dataCollected.title')}</h2>
          <p>{t('privacyPolicy.dataCollected.text')}</p>
          <ul>
            <li>{t('privacyPolicy.dataCollected.item1')}</li>
            <li>{t('privacyPolicy.dataCollected.item2')}</li>
            <li>{t('privacyPolicy.dataCollected.item3')}</li>
            <li>{t('privacyPolicy.dataCollected.item4')}</li>
            <li>{t('privacyPolicy.dataCollected.item5')}</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>{t('privacyPolicy.purpose.title')}</h2>
          <p>{t('privacyPolicy.purpose.text')}</p>
        </section>

        <section className={styles.section}>
          <h2>{t('privacyPolicy.thirdParty.title')}</h2>
          <p>{t('privacyPolicy.thirdParty.emailjs')}</p>
          <p>{t('privacyPolicy.thirdParty.recaptcha')}</p>
        </section>

        <section className={styles.section}>
          <h2>{t('privacyPolicy.localStorage.title')}</h2>
          <p>{t('privacyPolicy.localStorage.text')}</p>
        </section>

        <section className={styles.section}>
          <h2>{t('privacyPolicy.cookies.title')}</h2>
          <p>{t('privacyPolicy.cookies.text')}</p>
        </section>

        <section className={styles.section}>
          <h2>{t('privacyPolicy.retention.title')}</h2>
          <p>{t('privacyPolicy.retention.text')}</p>
        </section>

        <section className={styles.section}>
          <h2>{t('privacyPolicy.changes.title')}</h2>
          <p>{t('privacyPolicy.changes.text')}</p>
        </section>

        <section className={styles.section}>
          <h2>{t('privacyPolicy.contactSection.title')}</h2>
          <p>{t('privacyPolicy.contactSection.text')}</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
